import Paper from '@mui/material/Paper';
import { useTranslation } from 'react-i18next';
import ListItem from '@mui/material/ListItem';
import List from '@mui/material/List';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import { colorPalette } from '@repo/mui-config/color-palette';
import type { MerchantResponse } from '@repo/api/endpoints/merchant';

import { SectionHeader } from './section-header';

interface ShopList {
  merchantResponseData: MerchantResponse;
}
export function ShopList({ merchantResponseData }: ShopList) {
  const { t } = useTranslation();

  return (
    <Paper sx={{ padding: '16px 24px' }}>
      <SectionHeader>
        {t('loanProcess.loanSteps.agreementAndApprovals.loanRepayment.title')}
      </SectionHeader>
      <Typography>
        {t('loanProcess.loanSteps.agreementAndApprovals.loanRepayment.description')}
      </Typography>

      <List sx={{ maxHeight: '190px', overflowY: 'scroll' }}>
        {merchantResponseData.data.merchantData.shops.map((shop) => (
          <ListItem
            key={shop.id}
            sx={{
              paddingY: 1,
              paddingX: 0,
              borderBottom: `1px solid ${colorPalette.cloud.light}`,
            }}
          >
            <Stack direction="row" gap={0.5}>
              <Typography fontWeight={700} key={shop.id} sx={{ mr: 1 }}>
                {shop.id}
              </Typography>
              <Typography>{shop.name}</Typography>
            </Stack>
          </ListItem>
        ))}
      </List>
    </Paper>
  );
}
